import { toast } from "react-toastify";
import { formatMessage } from "../../translations/connectedIntlProvider";
import URLConstants from "../constants/url.constants";
import * as services from "./services";

export const onDownLinkTest =(iccid:string, jsonText:string, mode:string) =>{
    const downLinkData = {
      "ICCID": iccid,
      "DesiredValueJSON": jsonText,
	  "Mode": mode
    }
		let url = URLConstants.SetDeviceDesiredValue;
		services.post(url, downLinkData)
			.then(response => {
				 toast.success(formatMessage("DownLink_Test_Successfull"));
			})
			.catch(err => {
				toast.error(formatMessage('Message_Some_Error_Occured'));
				console.log(err);
			});
  }

  interface IDataType{
    ICCIDs:string[],
  }
  export const getDeviceState =(iccid:string,setInitialValues:any) =>{
    const data:IDataType = {
      ICCIDs:[]
    };
    const iccidsArray = data.ICCIDs;
    iccidsArray.push(iccid);
		let url = URLConstants.GetDeviceState;
		services.post(url, data)
			.then(response => {
          setInitialValues({ICCID:iccid,recievedJSONText:response.data[0].ReportedState})
				//  toast.success(formatMessage("DownLink_Test_Successfull"));
			})
			.catch(err => {
				toast.error(formatMessage('Message_Some_Error_Occured'));
				console.log(err);
			});
  }